import { render, staticRenderFns } from "./MetadataManagement.vue?vue&type=template&id=b1fb65b6"
import script from "./MetadataManagement.vue?vue&type=script&lang=js"
export * from "./MetadataManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports